import axios from "../../axios";
import { API } from "../../constants";
import i18n from "../../i18n";
import * as actionTypes from "./actionTypes";
import { setUserInfo } from "./auth";

export const setUser = (data) => {
  return {
    type: actionTypes.SET_USER,
    user: data,
  };
};

export const setUserInfoAndUpdateToken = (token) => {
  return {
    type: actionTypes.SET_USER_INFO_UPDATE_TOKEN,
    new_token: token,
  };
};

export const setUserLoading = () => {
  return {
    type: actionTypes.FETCH_USER_STARTING,
  };
};

export const fetchUserFailed = (error) => {
  return {
    type: actionTypes.FETCH_USER_FAILED,
    error: error,
  };
};

export const getUserInfo = () => {
  return (dispatch) => {
    dispatch(setUserLoading());
    axios
      .get(`${API}${i18n.language}/user/me`)
      .then((response) => {
        console.log("user", response.data.customer);
        dispatch(setUser(response.data.customer));
      })
      .catch((error) => {
        dispatch(fetchUserFailed());
      });
  };
};

export const updateUserInfo = (values) => {
  return (dispatch) => {
    dispatch(setUserLoading());
    axios
      .put(`${API}${i18n.language}/user/me`, {
        customer: values,
      })
      .then((response) => {
        console.log("update", response);
        dispatch(setUser(values));
      })
      .catch((error) => {
        dispatch(fetchUserFailed());
      });
  };
};

export const registerNewAngel = (values) => {
  return async (dispatch) => {
    dispatch(setUserLoading());

    return await axios
      .post(`${API}${i18n.language}/user/angel/me`, {
        angel: values,
      })
      .then((response) => {
        console.log("update", response);
        dispatch(setUser(values));
        dispatch(setUserInfo(response.data.token));
        dispatch(setUserInfoAndUpdateToken(response.data.token));
        return true;
      })
      .catch((error) => {
        dispatch(fetchUserFailed(error.response.data.error));
        return false;
      });
  };
};
